import { useSelector } from 'react-redux'
import { useAddNotificationMutation } from '@/features/notify-me/api'
import { useAppDispatch } from '@/redux/hooks'
import {
  useDeleteSavedSearchMutation,
  useNewSavedSearchMutation,
  useSavedSearchQuery,
} from '../api'
import { searchSelectors, setCurrentSavedSearch } from '../slice'
import type { SavedSearch } from '../types'

export const useSavedSearch = () => {
  const dispatch = useAppDispatch()

  return {
    getCurrentSavedSearch: () =>
      useSelector(searchSelectors.selectCurrentSavedSearch),
    setSelectedSavedSearch: (savedSearch: SavedSearch | null) =>
      dispatch(setCurrentSavedSearch(savedSearch)),
    useSavedSearchQuery,
    useDeleteSavedSearchMutation,
    useNewSavedSearchMutation,
    useAddNotificationMutation,
  }
}
